import { computed } from 'vue';

export function usePrefillParams() {
  // Get global variables that are injected via Wordpress (tpl-spa-funnel-v3.php) based on $_POST object.
  // These variables are sent from the prefill forms (i.e. https://www.alpina.nl/autoverzekering/)
  const newKenteken = window.prefillLicensePlate ?? false;
  const newKentekenOnbekend = window.prefillLicensePlateUnkown ?? false;
  const newPostcode = window.prefillZipcode ?? false;
  const newHuisnummer = window.prefillHouseNumber ?? false;
  const newToevoeging = window.prefillHouseNumberAddition ?? false;

  // These variables are for insuretostudy.com
  const newLandOorsprong = window.prefillOriginCountry ?? false;
  const newLandBestemming = window.prefillDestinationCountry ?? false;

  const hasPrefillParams = computed(() => {
    return (
      newKenteken || newPostcode || newHuisnummer || newToevoeging || newKentekenOnbekend || newLandOorsprong || newLandBestemming
    );
  });

  const vehiclePrefillLoader = computed(() => {
    return newKenteken.length >= 6 && newHuisnummer !== '' && newPostcode.length === 6;
  });

  return {
    newKenteken,
    newPostcode,
    newHuisnummer,
    newToevoeging,
    newKentekenOnbekend,
    newLandOorsprong,
    newLandBestemming,
    hasPrefillParams,
    vehiclePrefillLoader,
  };
}

export function useUrlParams() {
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);

  const newSha = params.get('sha') ?? false;
  const newMedewerker = params.get('medewerker') ?? '0';
  const provisieKey = params.get('p_key') ?? false;
  const isDev = params.get('dev') ?? '0';
  const vestigingKey = params.get('vkey') ?? '';
  const collectiviteitsCode = params.get('cc') ?? '';
  const paymentStatus = params.get('status') ?? false;

  const hasUrlParams = computed(() => {
    let hasValues = false;
    const prefills = Array.from(params);
    prefills.forEach((prefill) => {
      if (prefill[1] || prefill[0] === 'prefill_kenteken') hasValues = true;
    });
    return prefills.length > 0 && hasValues;
  });

  const removeHistory = (params = []) => {
    const location = window.location;
    const searchParams = new URLSearchParams(location.search);
    params.forEach((p) => {
      searchParams.delete(p);
    });

    // Remove the search params from the URL, but keep the hash.
    history.replaceState(null, '', '?' + searchParams.toString() + window.location.hash);
  };

  return {
    newSha,
    newMedewerker,
    provisieKey,
    vestigingKey,
    collectiviteitsCode,
    isDev,
    paymentStatus,
    hasUrlParams,
    removeHistory,
  };
}
